<script setup>
import { modulisticaPage } from '@/graphql/queries/modulistica.js'

definePageMeta({
  layout: 'default',
})

const { locale } = useI18n()

const variables = computed(() => ({
  locale: locale.value,
}))

const { data } = await useGraphql(modulisticaPage, variables)

if (!data.value.paginaModulistica) {
  throw createError({ statusCode: 404 })
}

const page = computed(() => data?.value?.paginaModulistica || {})
const seo = computed(() => page?.value?.seo || {})

useSeo(seo)
</script>

<template>
  <div class="modulistica-page row-400-25-default max-content">
    <div class="p-top-xxl-2">
      <LazyTitleText v-if="page.intro" :block="page.intro" />
      <LazyModulisticaBlock :block="page.modulistica" />
    </div>
  </div>
</template>

<script>
export default {
  name: 'ModulisticaPage',
}
</script>
